<template>
  <div class="names-page">
    <h1 class="heading">
      <b>[&nbsp;</b>
      <i>Introduce yourself</i>
      <b>&nbsp;]</b>
    </h1>

    <ul class="names-list">
      <li v-for="(user, index) in usersList" :key="user.key">
        <b>></b>
        {{ user.name
        }}<b v-show="index < Object.keys(usersList).length - 1">,</b
        ><b v-show="index == Object.keys(usersList).length - 1">.</b>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "names-page",
  computed: { ...mapGetters(["usersList"]) },
  filters: {
    leadingZero: function (value) {
      if (!value) {
        return "";
      } else if (value < 10) {
        return "0" + value;
      } else {
        return value;
      }
    },
  },
};
</script>

<style lang="scss" scoped >
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.names-page {
  background-image: url("~@/assets/images/page-blank.png");
  width: 768px;
  height: 768px;
  padding: 120px;
  position: relative;

  .heading {
    margin-bottom: 1em;
  }

  .names-list {
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: 30px;
    font-weight: 100;
    max-height: 530px;
    overflow: auto;

    li {
      margin-bottom: 5px;
      opacity: 0;
      animation: fadeIn 2s 1;
      animation-fill-mode: forwards;

      @for $i from 1 through 30 {
        &:nth-child(#{$i + 1}) {
          animation-delay: $i * 20s;
        }
      }
    }

    // .name-id {
    //   display: inline-block;
    //   width: 2.4em;

    //   i {
    //     display: inline-block;
    //     width: 45px;
    //     text-align: center;
    //   }
    // }
  }
}
</style>
